import { cloneElement, isValidElement, useId, type ReactElement, type ReactNode } from "react";
import { Label } from "@/components/ui/label";

/**
 * A label tied to its control (htmlFor/id) plus an optional inline error. The control must be a single
 * element (Input, Textarea or a native select); it gets the id, aria-invalid and aria-describedby.
 */
export function LegalField({ label, error, hint, children, className }: { label: ReactNode; error?: string | null; hint?: string; children: ReactElement; className?: string }) {
  const id = useId();
  const msgId = `${id}-msg`;
  const control = isValidElement(children)
    ? cloneElement(children as ReactElement<Record<string, unknown>>, {
        id,
        ...(error ? { "aria-invalid": true } : {}),
        ...(error || hint ? { "aria-describedby": msgId } : {}),
      })
    : children;
  return (
    <div className={className}>
      <Label htmlFor={id}>{label}</Label>
      {control}
      {error ? <p id={msgId} role="alert" className="text-xs text-destructive mt-1">{error}</p>
        : hint ? <p id={msgId} className="text-xs text-muted-foreground mt-1">{hint}</p> : null}
    </div>
  );
}
